export default __webpack_public_path__ + "static/media/fridge1-before2-1920w.3eb74a68.png";